/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAlarm = createReactComponent("alarm", "IconAlarm", [
  ["path", { d: "M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", key: "svg-0" }],
  ["path", { d: "M12 10l0 3l2 0", key: "svg-1" }],
  ["path", { d: "M7 4l-2.75 2", key: "svg-2" }],
  ["path", { d: "M17 4l2.75 2", key: "svg-3" }]
]);

export { IconAlarm as default };
//# sourceMappingURL=IconAlarm.js.map
